import Vue from 'vue';

export default new Vue();



// WEBPACK FOOTER //
// ./vue_merge_request_widget/event_hub.js